import _ from "lodash";
import { StatusProposta } from "@/enums";

const S = StatusProposta;

export const INICIAL = "INICIAL";
export const REGRAS = "REGRAS";
export const CANCELADA = "CANCELADA";

export const ERRO = "ERRO";
export const FIM = "FIM";

export const PROGRESS = "PROGRESS";
export const DONE = "DONE";

export const stepError = (document, response, step = ERRO) =>
  Promise.reject({
    document,
    step,
    response,
  });


export class AAError {
  static is = (e) => e.constructor === AAError;

  constructor(response) {
    this.detail = response;
  }
}

export class Job {
  wasApproved() {
    throw new Error("Job:wasApproved not implemented");
  }

  approved() {
    throw new Error("Job:approved not implemented");
  }

  rejected() {
    throw new Error("Job:rejected not implemented");
  }

  detectError(document, error) {
    this.status = ERRO;

    if (!AAError.is(error)) {
      this.detail = "Ocorreu um erro na solicitação...";
    }
    this.status = ERRO;
    return stepError(document, error);
  }

  async work(scope, { document, step }) {
    const self = this;
    try {
      return await scope[self.use](document)
        .then((response) => {
          return self.wasApproved(response)
            ? self.approved(document, response)
            : self.rejected(response);
        })
        .catch((error) => self.detectError(document, error));
    } catch (error) {
      return self.detectError(document, error);
    }
  }
}

export class Inicial extends Job {
  static failedApproval = [];

  constructor() {
    super();
    this.name = INICIAL;
    this.status = PROGRESS;
    this.text = "Salvando a proposta de endosso...";
    this.detail = null;
    this.use = "createEndorsement";
  }

  wasApproved(response) {
    return response.cd_retorno === 0;
  }

  approved(document, response) {
    const { id_endosso_gerado } = response;
    this.status = DONE;
    this.text = `Proposta de Endosso n° ${id_endosso_gerado} criada com sucesso.`;
    return {
      document: response,
      step: REGRAS,
    };
  }

  rejected(response) {
    this.detail = "Não foi possivel salvar a proposta.";
    throw new AAError(response);
  }
}

export class Regras extends Job {
  // TODO(dias): first item is missing from the enum...
  static failedApproval = [];

  constructor() {
    super();
    this.name = REGRAS;
    this.status = PROGRESS;
    this.text = "Aprovação automática...";
    this.detail = null;
    this.use = "automaticApproval";
  }

  wasApproved(response) {
    // NOTE: it seems that it's always an array.
    return response && response.length === 0;
  }

  approved(document, response) {
    this.status = DONE;
    this.text = "Aprovado automaticamente.";
    return {
      document: response,
      step: FIM,
    };
  }

  rejected(response) {
    this.detail = response;
    throw new AAError(response);
  }
}

export const automaticApproval = {
  [INICIAL]: Inicial,
  [REGRAS]: Regras,
};

/**
 * This is the strategy that runs the automatic approval.
 * Given a scope (component), context, a steps table.
 */
export const oneAtATimeStrategy = (scope, context, steps) =>
  new Promise(async (resolve, reject) => {
    let step, current;
    try {
      for (
        step = context.step;
        !["ERRO", "FIM"].includes(step);
        step = context.step
      ) {
        current = new steps[step]();
        // on init
        scope.state.current = current;
        await scope.sync();
        // on execute
        context = await current.work(scope, context);
        // on complete
        scope.state = {
          stack: scope.state.stack.concat([current]),
          current: null,
        };
      }
      resolve(context);
    } catch (e) {
      const $error = e;
      console.error(JSON.stringify($error));
      reject($error);
    }
  });



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/AutomaticApproval.js